import { render, staticRenderFns } from "./CurrencyCard.vue?vue&type=template&id=b99128ae&"
import script from "./CurrencyCard.vue?vue&type=script&lang=js&"
export * from "./CurrencyCard.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyCard.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports